module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d7eb1e753d603d291d24509c5389d92b.jpg";